"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const UNITS = {
    px: { px: () => 1 },
    pt: { px: () => 1 / 0.75 },
    in: { px: (dpi) => dpi },
    cm: { px: (dpi) => dpi / 2.54 },
};
/**
 * Converts the given value to the provided length unit.
 *
 * @Example
 *
 *   convertLengthUnit(10, { from: 'px', to: 'pt' })
 *   //=> 7.5
 *
 *   convertLengthUnit(10, { from: 'px', to: 'in', dpi: 100 })
 *   //=> 0.3
 */
function convertLengthUnit(value, { from, to, dpi = 300 }) {
    const pxValue = value * UNITS[from].px(dpi);
    return pxValue / UNITS[to].px(dpi);
}
exports.convertLengthUnit = convertLengthUnit;
//# sourceMappingURL=convert-length-unit.js.map